import IconButton from '@mui/material/IconButton';
import React from 'react';

import { useCampusComparison } from '../../../hooks/useCampusComparison';
import { useKioskManager } from '../../../hooks/useKioskManager';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import styles from './DirectionsList.module.scss';

interface DirectionsListProps {
  onClick: (value: boolean) => void;
  collapsed: boolean;
  title?: string;
  whereTo: string;
  children: React.ReactNode;
  legOne?: boolean;
  printMode?: boolean;
}
export const DirectionsList: React.FC<DirectionsListProps> = ({
  onClick,
  collapsed,
  title,
  whereTo,
  children,
  legOne,
  printMode = false,
}) => {
  const { kiosk, kioskMode } = useKioskManager();
  const { isSameCampus } = useCampusComparison();

  return (
    <div
      className={`
    ${styles.container}
    ${!collapsed && styles.focused}
    ${printMode && styles.print}
    ${kiosk && kioskMode && styles[kiosk.model]}
  `}
    >
      <div className={styles.wrapper}>
        {!isSameCampus && (
          <div className={styles.stepHeader}>
            <span className={styles.title}>
              {title && title}
              {!printMode && (
                <IconButton
                  aria-label="Collapse"
                  onClick={() => onClick(!collapsed)}
                >
                  <Icon
                    icon={collapsed ? IconType.DOWN : IconType.UP}
                    ariaLabel="Collapse"
                  />
                </IconButton>
              )}
            </span>

            <div className={styles.whereTo}>
              {legOne ? (
                <Icon icon={IconType.CAR} />
              ) : (
                <Icon icon={IconType.WALKING} />
              )}
              {whereTo}
            </div>
          </div>
        )}
        {(!collapsed || isSameCampus) && children}
      </div>
    </div>
  );
};
